<template>
  <div>
    <vl-map :load-tiles-while-animating="true" :load-tiles-while-interacting="true"
             data-projection="EPSG:4326" :style="styleMaxHeight">
      <vl-view :zoom.sync="zoom" :center.sync="center" :rotation.sync="rotation"></vl-view>
         <vl-feature id="marker" ref="marker" :properties="{ start: Date.now(), duration: 2500 }">
        <template slot-scope="feature">
          <vl-geom-point :coordinates="center"></vl-geom-point>
          <vl-style-box>
            <vl-style-icon src="/images/map/marker.png" :scale="0.5" :anchor="[0.1, 0.95]" :size="[128, 128]"></vl-style-icon>
          </vl-style-box>
          <!-- overlay binded to feature -->
          <vl-overlay v-if="feature.geometry" :position="pointOnSurface(feature.geometry)" :offset="[10, 10]">
            <p class="is-light box content">
              Always opened overlay for Feature ID <strong>{{ feature.id }}</strong>
            </p>
          </vl-overlay>
        </template>
      </vl-feature>
<!--
      <vl-geoloc @update:position="geolocPosition = $event">
        <template slot-scope="geoloc">
          <vl-feature v-if="geoloc.position" id="position-feature">
            <vl-geom-point :coordinates="geoloc.position"></vl-geom-point>
            <vl-style-box>
              <vl-style-icon src="_media/marker.png" :scale="0.4" :anchor="[0.5, 1]"></vl-style-icon>
            </vl-style-box>
          </vl-feature>
        </template>
      </vl-geoloc>
-->
      <vl-layer-tile id="osm">
        <vl-source-osm></vl-source-osm>
      </vl-layer-tile>
    </vl-map>
    <div style="padding: 20px" v-if="showSettings">
      Latitude/Longitude: {{latitude}}/{{longitude}} <br/>
      Zoom: {{ zoom }}<br>
      Center: {{ center }}<br>
      Rotation: {{ rotation }}<br>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dio-map',
  props: {
    latitude: {
      required: true,
      type: [Number, String]
    },
    longitude: {
      required: true,
      type: [Number, String]
    },
    initialZoom: {
      required: false,
      type: Number,
      default: 12
    },
    maxHeight: {
      required: false,
      type: String,
      default: '400px'
    },
    showSettings: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      zoom: this.initialZoom,
      // center: [Number(this.longitude), Number(this.latitude)],
      rotation: 0,
      geolocPosition: undefined
    }
  },
  computed: {
    center () {
      return [Number(this.longitude), Number(this.latitude)]
    },
    styleMaxHeight () {
      return `height: ${this.maxHeight}`
    }
  }
}
</script>
